
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/book",
      function () {
        return require("private-next-pages/marketplace/book/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/book"])
      });
    }
  